import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { Tutorial, TutorialMaterial } from '../../models/tutorial.model';
import { TutorialService } from '../../services/tutorial.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { TutorialItemListComponent } from '../tutorial-item-list/tutorial-item-list.component';
import { TutorialMaterialService } from '../../services/tutorial-class.service';

@Component({
  selector: 'app-tutorial-material-list',
  templateUrl: './tutorial-material-list.component.html',
  styleUrls: ['./tutorial-material-list.component.scss', './../../tutorial.scss']
})
export class TutorialMaterialListComponent extends BaseListComponent<Tutorial> implements OnInit, OnDestroy {
  
  isAdmin:boolean = false;
  isOrdering:boolean = false;
  id:number;
  currentItemId:number;
  data:Tutorial;

  @ViewChild('modal') modal: TemplateRef<any>;
  @ViewChild('modal_color') modalColor: TemplateRef<any>;
  @ViewChild(TutorialItemListComponent) itemList: TutorialItemListComponent;

  constructor(
    private tutorialService: TutorialService,
    private tutorialMaterialService: TutorialMaterialService,
    public activatedRoute: ActivatedRoute,
    public modalRef: BsModalRef,
    public modalColorRef: BsModalRef,
    private modalService: BsModalService,
    private navigation: NavigationService,
    private router: Router
  ) {
    super(); 
  }

  ngOnInit() {
    this.loading();
    this.id = this.activatedRoute.snapshot.params?.id;
    var type = this.activatedRoute.snapshot.data['userType'];
    this.isAdmin = type == 'admin'? true: false;
  }
  ngAfterViewInit(){
    this.start();
  }
  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  start(): void {
    this.tutorialService.getById(this.id).subscribe(
      (res) => {
        this.data = res;
        this.itemList.initForm(res?.tutorial_class);
        console.log(this.data)
        this.loaded();
      },
      (error) => {
        this.msgError(error?.error?.message);
        this.loaded();
      },
    )
  }

  voltar(): void {
    var type = this.isAdmin == true? 'admin': 'user';
    this.navigation.back(['tutorial/' + type + '/pesquisa-geral']);
  }
  
  openModal(id:number = null): void {
    event.stopPropagation();
    this.currentItemId = id;
    this.modalRef = this.modalService.show(this.modal,{class:"modal-m"});
  }
  openColorModal(): void {
    event.stopPropagation();
    this.modalColorRef = this.modalService.show(this.modalColor,{class:"modal-m"});
  }

  closeModal(modal): void {
    modal.hide();
  }
  
  sortData():TutorialMaterial[] {
    return this.data?.tutorial_class?.sort(function(a, b) {
      const itemA = this.getFormItem(a);
      const itemB = this.getFormItem(b);
      return itemA?.value?.nro_ord - itemB?.value?.nro_ord;
    }.bind(this)); 

  }

  saveOrder(): void{
    alert('todo salvar');
    this.isOrdering = false;
  }

  salvar(newData): void {
    this.loading();
    this.tutorialMaterialService.updateList(newData).subscribe({
      next: (res) => {
        this.msgSuccess('Ordem alterada com sucesso!');
        this.loaded();
      },
      error: (error) => {
        this.msgError(error.error.message);
        this.loaded();
      },
    });
  }

  excluir(id: any): void {
    this.loading();
    this.tutorialMaterialService.delete(id).subscribe({
      next: (res) => {
        this.msgSuccess('Deletado com sucesso!');
        this.loaded();
        window.location.reload();
      },
      error: (error) => {
        this.loaded();
      }
    });
  }

  saveList(newData): void {
    this.loading();
    this.tutorialMaterialService.updateList(newData).subscribe({
      next: (res) => {
        this.confirmation("Ordem alterada com sucesso!").subscribe(() => {
          window.location.reload();
        });
        this.loaded();
      },
      error: (error) => {
        let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
        this.msgError(msg);
        this.loaded();
      },
    });
  }

  deleteList(ids:number[]):void{
    console.log(ids)
    this.loading();
    this.tutorialMaterialService.deleteList(ids).subscribe({
      next: (res) => {
        this.confirmation("Deletado com sucesso!").subscribe(() => {
          window.location.reload();
        });
        this.loaded();
      },
      error: (error) => {
        let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
        this.msgError(msg);
        this.loaded();
      },
    });
  }

  changeShow(event: { id: number; status: boolean }):void{
    this.loading();
    var newData = { actived: event.status};
    this.tutorialMaterialService.uploadFile( event.id,newData,null).subscribe({
      next: (res) => {
        this.confirmation("Tutorial alterado com sucesso!").subscribe(() => {
          window.location.reload();
        })
        this.loaded();
      },
      error: (error) => {
        let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
        this.msgError(msg);
        this.loaded();
      },
    })
  }
  openFile(id:number):void{
    var type = this.isAdmin == true? 'admin': 'user';
    this.router.navigate(['tutorial/' + type + '/' + this.id + '/doc/' + id]);

  }
}
